import {useBleskAuth} from '@blesk-frontend/auth';
import {Button, Close} from '@blesk-frontend/ui';
import {useEffect, useState} from 'react';

export const teamMemberInviteHintKey = 'teamMemberInviteHint';

export const TeamMemberInviteHint = () => {
  const [isHint, setIsHint] = useState(false);
  const {
    query: {data: user},
  } = useBleskAuth();

  useEffect(() => {
    if (!user) {
      return;
    }

    const inviteHintValue = localStorage.getItem(teamMemberInviteHintKey);

    if (inviteHintValue === 'false') {
      setIsHint(false);
    } else {
      setIsHint(true);
      localStorage.setItem(teamMemberInviteHintKey, 'true');
    }
  }, [user]);

  if (!isHint) {
    return null;
  }

  const onClickClose = () => {
    setIsHint(false);
    localStorage.setItem(teamMemberInviteHintKey, 'false');
  };

  return (
    <div className="flex w-full max-w-screen-xl gap-6 rounded-lg border border-border-primary bg-warning-subtle p-6">
      <p className="flex-1 text-paragraph-md text-text-secondary">
        Пригласите в команду своих коллег, чтобы совместно работать над пошаговыми инструкциями
      </p>
      <Button type="button" variant="link" className="text-text-secondary" onClick={onClickClose}>
        <Close className="size-6" />
      </Button>
    </div>
  );
};
